import React from "react";
// import { PATH_APP } from './../routes/paths';
import { PATH_APP } from "../../routes/paths";
import PeopleIcon from "@material-ui/icons/People";
import EventIcon from "@material-ui/icons/Event";
import MessageIcon from "@material-ui/icons/Message";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
import ListIcon from "@material-ui/icons/List";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import HistoryIcon from "@material-ui/icons/History";
// ----------------------------------------------------------------------

const path = (name) => `/static/icons/navbar/${name}.svg`;
const ICONS = {
  peopleIcon: <PeopleIcon />,
  eventIcon: <EventIcon />,
  messageIcon: <MessageIcon />,
  NotificationImportantIcon: <NotificationImportantIcon />,
  ListIcon: <ListIcon />,
  EventAvailableIcon: <EventAvailableIcon />,
  HistoryIcon: <HistoryIcon />,
};

const navConfig = [
  {
    subheader: "ทั่วไป",
    items: [
      // {
      //   title: "ผังรายการ (OLD)",
      //   href: PATH_APP.insertProgram,
      //   icon: ICONS.eventIcon,
      //   role: 2,
      // },
      {
        title: "ผังรายการ",
        href: PATH_APP.notificationNew,
        icon: ICONS.eventIcon,
        role: 3,
      },
      // {
      //   title: "ผังรายการ Top Fan",
      //   href: PATH_APP.insertProgramTopfan,
      //   icon: ICONS.EventAvailableIcon,
      //   role: 2,
      // },
      {
        title: "ส่งข้อความทันที",
        href: PATH_APP.adminBoardCast,
        icon: ICONS.messageIcon,
        role: 3,
      },
      {
        title: "ประวัติการส่ง Broadcast",
        href: PATH_APP.notiLog,
        icon: ICONS.HistoryIcon,
        role: 2,
      },
      {
        title: "ผู้ใช้",
        href: PATH_APP.groupList,
        icon: ICONS.ListIcon,
        role: 2,
        submenu: [
          {
            title: "ผู้ใช้ตามกลุ่ม",
            href: PATH_APP.groupList,
            icon: ICONS.ListIcon,
            role: 2,
          },
          {
            title: "ผู้ใช้งาน",
            href: PATH_APP.users,
            icon: ICONS.peopleIcon,
            role: 2,
          },
        ]
      },
      {
        title: "ทดสอบ Notification",
        href: PATH_APP.test_notification,
        icon: ICONS.NotificationImportantIcon,
        role: 0,
      },
    ],
  },
];

export default navConfig;
